module.exports = __webpack_public_path__ + "static/media/5CrisisLines.f6315430.png";